import { render } from "./ImportPage.vue?vue&type=template&id=23467b8c&scoped=true"
import script from "./ImportPage.vue?vue&type=script&lang=js"
export * from "./ImportPage.vue?vue&type=script&lang=js"

import "./ImportPage.vue?vue&type=style&index=0&id=23467b8c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23467b8c"]])

export default __exports__